export const sendIcon = `
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5478 0.935059L8.7781 13.9999L5.25621 10.4526L10.7148 3.777L4.02537 9.21978L0.5 5.69643L13.5478 0.935059Z" fill="white"/>
</svg>
`;
